export default {"src":"/_next/static/media/auto.aac172be.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};